export default __webpack_public_path__ + "static/media/bloodyhack1.64faf300.png";